import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-202d8a8e"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "small" }
const _hoisted_3 = { class: "float-right-total" }
const _hoisted_4 = { class: "box-info" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Formas de pagamento: ", -1))
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Troco para: ", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Dados do cliente:")
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Nome:", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Endereço:", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Número:", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Complemento:", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Referência: ", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Bairro: ", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Cidade: ", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "UF: ", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "CEP: ", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Horário do pedido: ", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Horário previsto entrega: ", -1))

import { IonHeader, 
        IonToolbar,
        IonIcon,
        IonTitle,
        IonPage, 
        IonList, 
        IonItem, 
        IonThumbnail, 
        IonLabel, 
        IonContent ,
        IonGrid, 
        IonRow, 
        IonCol,
        IonCard,
        IonCardHeader,
        IonCardTitle,
        IonCardSubtitle,
        IonCardContent,
        IonButton
        } from '@ionic/vue';
import { useStore } from 'vuex';
import { arrowBackOutline } from 'ionicons/icons';
import { reactive, ref, computed , onMounted, onUpdated } from 'vue';
import { key } from '../store/index';
import moment from 'moment';
import router from '@/router';


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckoutThankyou',
  setup(__props) {

const store = useStore(key);

let cartdata = reactive(store.state.cart);

const user = reactive(store.state.user);

const dtpedido = reactive(store.state.datapedido);

// const dtpedido = ref();
// watch(dtpedido, (dtpedido)=>{
//     return store.state.datapedido
// })

onMounted(()=>{
    cartdata = store.state.cart 
})

onUpdated(() => {
    cartdata = store.state.cart 
})


const dtagenda = computed(()=>{
    const dt = moment(store.state.datapedido?.agendamentopedido).utc(0).add(-2, 'h').format('DD/MM/YYYY - HH:mm');
    console.log('dtagenda', dt);
    // console.log('dtpedido', dtpedido);
    return dt;
})

const datapedido = computed(()=>{
    const dt = moment(store.state.datapedido?.datarealizadopedido).utc(0).add(-2, 'h').format('DD/MM/YYYY - HH:mm');
    console.log('dtatual', dt);
    // console.log('dtpedido', dtpedido);
    return dt;
})

// const pgto = computed(()=>{
//     const pg = dtpedido.pagamento;
//     console.log('pagamento', pg);
//     return pg;
// })

const dataagenda = ref(dtagenda);

const totalCart  = computed(()=>{
    return (store.state.totalcart).toFixed(2).replace('.',',');
});

const pednum  = computed(()=>{
    return (store.state.pedido);
});

const userForAddress = computed(()=>{
    const us = store.state.user;
    const indexuseradd = store.state.user.length -1;
    return us[indexuseradd];
})

// const datahoraagora = ref();
// const datamaxima = ref();


// const datenow = moment().utc(3).toISOString().replace(/.\d+Z$/g, "Z");
// const datamin = moment().utc(3).add(1, 'h').toISOString().replace(/.\d+Z$/g, "Z");
// const datemax = moment().utc(3).add(1, 'd').toISOString().replace(/.\d+Z$/g, "Z");

// // datahoraagora.value = moment.ISO_8601(yourDate);
// const datahoraagora = ref(datenow.toString());
// const datamaxima = ref(datemax.toString());
// const dataminima = ref(datamin.toString());

// const dataagenda = ref('');
// const valortroco = ref();

//console.log('dm', dataminima.value)
function upper(txt: string){
    return txt.toUpperCase();
}
function numberPreco(preco: number){
    const prc: string = preco.toFixed(2).toString();
    return prc.replace(".", ",");
    // return preco;
}

function alterarPedido(){
    router.push('/')
}

function retornarInicial(){
    store.dispatch('clearBaseStore');
    router.push('/');
    // setTimeout(()=>{
    //     store.dispatch('clearAllStore');
    // } ,500)
    
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonHeader), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonToolbar), { color: "danger" }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonIcon), {
                icon: _unref(arrowBackOutline),
                slot: "start",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goBack()))
              }, null, 8, ["icon"]),
              _createVNode(_unref(IonTitle), null, {
                default: _withCtx(() => [
                  _createTextVNode("Checkout Uniboi")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonContent), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonGrid), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonRow), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonCol), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonCard), null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonCardHeader), null, {
                            default: _withCtx(() => [
                              _createVNode(_unref(IonCardTitle), null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Pedido Confirmado")
                                ]),
                                _: 1
                              }),
                              _createVNode(_unref(IonCardSubtitle), { color: "danger" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Número do seu pedido: " + _toDisplayString(_unref(pednum).id), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(IonCardContent), null, {
                            default: _withCtx(() => [
                              (_unref(cartdata).length > 0)
                                ? (_openBlock(), _createBlock(_unref(IonList), { key: 0 }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(cartdata), (itemcart, index) => {
                                        return (_openBlock(), _createBlock(_unref(IonItem), { key: index }, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(IonThumbnail), { slot: "start" }, {
                                              default: _withCtx(() => [
                                                _createElementVNode("img", {
                                                  alt: "image",
                                                  src: itemcart.cloud_image_url
                                                }, null, 8, _hoisted_1)
                                              ]),
                                              _: 2
                                            }, 1024),
                                            _createVNode(_unref(IonLabel), null, {
                                              default: _withCtx(() => [
                                                _createElementVNode("h3", null, _toDisplayString(upper(itemcart.nome)), 1),
                                                _createElementVNode("p", null, _toDisplayString(upper(itemcart.pdescricao)), 1),
                                                _createElementVNode("p", null, "Quant: " + _toDisplayString(itemcart.quantItem), 1)
                                              ]),
                                              _: 2
                                            }, 1024),
                                            _createVNode(_unref(IonLabel), { slot: "end" }, {
                                              default: _withCtx(() => [
                                                _createElementVNode("p", _hoisted_2, "R$ " + _toDisplayString(numberPreco(itemcart.totalitem)), 1)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1024))
                                      }), 128)),
                                      _createVNode(_unref(IonItem), null, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(IonLabel), {
                                            class: "mini",
                                            slot: "start"
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode("Taxa de entrega")
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_unref(IonLabel), {
                                            class: "mini",
                                            slot: "end"
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode("R$ 0,00")
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createElementVNode("p", _hoisted_3, "Total Pedido: R$ " + _toDisplayString(_unref(totalCart)), 1)
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("p", null, [
                                  _hoisted_5,
                                  _createTextVNode(_toDisplayString(dtpedido.pagamento), 1)
                                ]),
                                (dtpedido.pagamento == 'DINHEIRO')
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_6, [
                                      _hoisted_7,
                                      _createTextVNode(" R$ " + _toDisplayString(dtpedido.troco), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                _hoisted_8,
                                _createElementVNode("p", null, [
                                  _hoisted_9,
                                  _createTextVNode(" " + _toDisplayString(user[0].nome) + " " + _toDisplayString(user[0].sobrenome), 1)
                                ]),
                                _createElementVNode("p", null, [
                                  _hoisted_10,
                                  _createTextVNode(" " + _toDisplayString(_unref(userForAddress).endereco), 1)
                                ]),
                                _createElementVNode("p", null, [
                                  _hoisted_11,
                                  _createTextVNode(" " + _toDisplayString(_unref(userForAddress).numero), 1)
                                ]),
                                _createElementVNode("p", null, [
                                  _hoisted_12,
                                  _createTextVNode(" " + _toDisplayString(_unref(userForAddress).complemento), 1)
                                ]),
                                _createElementVNode("p", null, [
                                  _hoisted_13,
                                  _createTextVNode(_toDisplayString(_unref(userForAddress).referencia), 1)
                                ]),
                                _createElementVNode("p", null, [
                                  _hoisted_14,
                                  _createTextVNode(_toDisplayString(_unref(userForAddress).bairro) + " - ", 1),
                                  _hoisted_15,
                                  _createTextVNode(_toDisplayString(_unref(userForAddress).cidade) + " - ", 1),
                                  _hoisted_16,
                                  _createTextVNode(_toDisplayString(_unref(userForAddress).uf), 1)
                                ]),
                                _createElementVNode("p", null, [
                                  _hoisted_17,
                                  _createTextVNode(_toDisplayString(_unref(userForAddress).cep.substring(0,5)) + "-" + _toDisplayString((_unref(userForAddress).cep).substring(5,)), 1)
                                ]),
                                _createElementVNode("p", null, [
                                  _hoisted_18,
                                  _createTextVNode(_toDisplayString(_unref(datapedido)), 1)
                                ]),
                                _createElementVNode("p", null, [
                                  _hoisted_19,
                                  _createTextVNode(_toDisplayString(dataagenda.value), 1)
                                ])
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(IonRow), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonCol), { class: "ion-text-center" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonButton), {
                        color: "secondary",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (retornarInicial()))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Voltar início")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})